import React, {useState} from 'react'
import {PublicKanbanCard} from './PublicKanbanCard'
import './PublicClient.css'

interface Task {
  id: number
  name: string
  priority: string
  status: string
  project_name: string
  total_time: number
  users: Array<{
    name: string
    avatar: string
  }>
  hasTag: boolean
  hasChecklist: boolean
  hasDeadline: boolean
  expected_date?: string
  isOverdue?: boolean
  color?: string
}

interface PublicKanbanColumnProps {
  id: string
  title: string
  color: string
  tasks: Task[]
  formatTime: (minutes: number) => string
  clientUrl?: string
  isAuthenticated?: boolean
  token?: string | null
}

// Projetos grandes chegam a centenas de tarefas por coluna: renderiza em lotes.
const PAGE_SIZE = 20

const PublicKanbanColumn: React.FC<PublicKanbanColumnProps> = ({
  title,
  color,
  tasks,
  formatTime,
}) => {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)
  const remaining = tasks.length - visibleCount

  return (
    <section className={`pc-kcol pc-kcol-${color}`} data-color={color} aria-label={title}>
      <header className='pc-kcol-head'>
        <h3 className='pc-kcol-title'>{title}</h3>
        <span className='badge kanban-count-badge rounded-pill ms-auto'>{tasks.length}</span>
      </header>

      <div className='pc-kcol-list'>
        {tasks.slice(0, visibleCount).map((task) => (
          <PublicKanbanCard
            key={task.id}
            task={task}
            formatTime={formatTime}
            showDeliveryFooter={color === 'done'}
          />
        ))}

        {tasks.length === 0 && <div className='pc-kcol-empty'>Nenhuma tarefa</div>}

        {remaining > 0 && (
          <button
            type='button'
            className='pc-kmore'
            onClick={() => setVisibleCount((count) => count + PAGE_SIZE)}
          >
            Ver mais ({remaining})
          </button>
        )}
      </div>
    </section>
  )
}

export {PublicKanbanColumn}
